var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateConversionFunnel',{attrs:{"client-is-required":true,"route":_vm.$listRoutes.dashboardsFunnel,"filters-route":'#',"events":['purchase_view_item', 'purchase_add_to_cart', 'purchase_checkout_started', 'purchase_completed'],"comparaison":true,"title":_vm.$t('dashboard-funnel-buying.title')}})
}
var staticRenderFns = []

export { render, staticRenderFns }